import { memo } from 'react';

import { Portal } from '@air/primitive-portal';

import { ThreeBirdsFlyingVideo } from './ThreeBirdsFlyingVideo';

export const DropzoneOverlay = memo(() => {
  return (
    <Portal>
      <div
        /**
         * Because we're wrapping this in a Portal, the events from hovering over the overlay no longer propagate to the upload dropzone.
         * As a result, we need to disable pointer events for this overlay to ensure that mouse events are done on the upload dropzone and
         * not the overlay.
         */
        className="pointer-events-none fixed inset-0 z-portal flex size-full flex-col items-center justify-center bg-gray-1 text-gray-12"
      >
        <ThreeBirdsFlyingVideo />
        <h1 className="mt-24 font-semibold text-gray-12">Drop files anywhere to upload</h1>
      </div>
    </Portal>
  );
});

DropzoneOverlay.displayName = 'DropzoneOverlay';
